var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert",class:{'alert--error': _vm.message.isError()},domProps:{"innerHTML":_vm._s(_vm.message.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }